<template>
  <div>
    <Search :isPC="isPC" :saleEstate="true"></Search>
    <Footer></Footer>
  </div>
</template>

<script>
import Search from '@/components/Search'
import Footer from '@/components/public/Footer'
export default {
  name: 'EstateSale',
  components:{
    'Search': Search,
    'Footer': Footer,
  },
  data () {
    return {
      isPC:this.$store.state.isPC,
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EstateSale.vue